import BusinessPage from './page';

export default BusinessPage;
